import { createSelector } from "reselect"

import Options from "../../records/Options"

const optionsSelector = state => state.options

export default createSelector(
  [optionsSelector],
  (options: Options) => `/${options.language}`,
)
